import React, { useState } from "react";
import API from "../../ApiService/ApiService";
import Context from "./index";
import Widget from "../../Helpers/Widget";
import { Form } from 'antd';
const TopicMasterProvider = (props) => {
  const api = new API();
  const [maxDuration, setMaxDuration] = useState(0);
  const [videoCatLoader, setVideoCatLoader] = useState(false);
  const [videoCatList, setVideoCatList] = useState([]);
  const [videoCatTableFilter, setVideoCatTableFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [videoListTable, setVideoListTable] = useState({
    name: "",
    page: 1,
    limit: 20,
    subject_id: [],
    topic_id: [],
    subcategory_id: [],
    topic_id_filter: "",
  })
  const [insTableFilter, setInsTableFilter] = useState({
    name: "",
    page: 1,
    limit: 20,
  });
  const [addInsPopup, setAddInsPopup] = useState(false);
  const [addInsLoader, setAddInsLoader] = useState(false);
  const [addInsFormData, setAddInsFormData] = useState({
    name: "",
    specialization: "",
    desciption: "",
    subject_id: "",
  });
  const [addVideoFormData, setAddVideoFormData] = useState({
    name: "",
    description: "",
    time_stamp_status: '',
    time_stamp_details: [
      {
        time: "00:00:00",
        description: ""
      }
    ],
    notes_type: "",
    notes_pdf: "",
    notes_image: "",
    notes_text: "",
    download_option: 0,
    free_playback_from: "",
    free_playback_to: "",
    video_id: "",
    video_details: {},
    status: "",
    notes_status: "",
    related_qbanks: [],
  })
  const [addInsForm] = Form.useForm();
  const [editInsForm] = Form.useForm();
  const [addVideoForm] = Form.useForm();
  const [editInsPopup, setEditInsPopup] = useState(false);
  const [editInsLoader, setEditInsLoader] = useState(false);
  const [getSingleIns, setGetSingleIns] = useState({});
  const [singleInsLoader, setSingleInsLoader] = useState(false);
  const [insSubjectList, setInsSubjectList] = useState([]);
  const [insSubjectLoader, setInsSubjectLoader] = useState(false);
  const [insList, setInsList] = useState([]);
  const [insTableLoader, setInsTableLoader] = useState(false);
  const [addVideoLoader, setAddVideoLoader] = useState(false);
  const [addVideoPopup, setAddVideoPopup] = useState(false);
  const [videoList, setVideoList] = useState([]);
  const [verifyLoader, setVerifyLoader] = useState(false);
  const [videoListLoader, setVideoListLoader] = useState(false);
  const [updateVideoLoader, setUpdateVideoLoader] = useState(false);
  const [singleVideoLoader, setSingleVideoLoader] = useState(false);
  const [rQBLoader, setRQBVideoLoader] = useState(false);
  const [rQBList, setRQBVideoList] = useState([]);
  const [singleVideo, setSingleVideo] = useState({});
  const [videoTList, setVideoTList] = useState([]);
  const [videoTLoader, setVideoTLoader] = useState(false);
  const [deleteVideoLoader, setDeleteVideoLoader] = useState(false);
  const [gumletVideoStatusLoader, setGumletVideoStatusLoader] = useState(false);
  const [gumletAssetId, setGumletAssetId] = useState("");
  const [bulkActionVideoExam, setBulkActionVideoExam] = useState([]);
  const [bulkActionVideoExamLoader, setBulkActionVideoExamLoader] = useState(false);
  const [bulkActionVideoType, setBulkActionVideoType] = useState(false);

  const [fetRatingData, setFetRatingData] = useState([]);
  const [fetRatingDataLoader, setFetRatingDataLoader] = useState(false);
  const [updateRatingData, setUpdateRatingData] = useState(null);
  const [updateRatingDataLoader, setUpdateRatingDataLoader] = useState(false);
  const [updateRatingPopup, setUpdateRatingPopup] = useState(null);

  const getRatingData = async (category_id) => {
    setFetRatingDataLoader(true);
    await api.getAll("videos/get_star_rating_detailsv2",{
      category_id,
    }, (err, res) => {
      if (res?.data?.status === 200) {
        setFetRatingData(res?.data?.data);
      } else {
        setFetRatingData([]);
      }
      setFetRatingDataLoader(false);
    })
  }

  const getRatingDataUpdate = async () => {
    setUpdateRatingDataLoader(true);
    if (!updateRatingData) {
      Widget.showMessage("error", "Please select word file");
      setUpdateRatingDataLoader(false);
      return;
    }
    const formData = new FormData();
    formData.append("file", updateRatingData);
    await api.create("videos/get_star_rating_update", formData, (err, res) => {
      if (res?.data?.status === 200) {
        setUpdateRatingData(null)
        document.getElementById("excelFile11").value = "";
        setUpdateRatingDataLoader(false);
        setUpdateRatingPopup(false);
      } else {
        Widget.showMessage("error", "Invalid Excel Format");
      }
      setUpdateRatingDataLoader(false);
    })
  }



  const updateGumletVideoStatus = async (id,aid) => {
    setGumletVideoStatusLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll(`videos/gumletvideoverified/${id}/${aid}`, {}, (err, res) => {
        if (res?.data?.status === 200) {
          fetchSingleVideo(id);
          setGumletVideoStatusLoader(false);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
          setGumletVideoStatusLoader(false);
        }
      })
  }

  const deleteVideo = async (id,cid,callback=null) => {
    setDeleteVideoLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.remove("videos/deletevideos", id, (err, res) => {
        if (res?.data?.status === 200) {
          // fetchVideoListTable(cid);
          callback && callback(err, res);
          Widget.showMessage("success", res?.data?.message);
          setDeleteVideoLoader(false);
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
          setDeleteVideoLoader(false);
        }
      })
  }

  const videoRowUpdate = async (data, cid) => {
    localStorage.getItem("rxdx_admin_login") &&
      await api.create("videos/rowupdate", {ids:data}, (err, res) => {
        if (res?.data?.status === 200) {
          fetchVideoListTable1(cid);
        } else {
         
        }
      });
  };
  const fetchVideoTList = async () => {
    setVideoTLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("videos/videotopicdropdown", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setVideoTList(res?.data?.data);
          setVideoTLoader(false);
        } else {
          setVideoTList([]);
          setVideoTLoader(false);
        }
      });
  }
  const fetchRelatedQB = async () => {
    setRQBVideoLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("videos/videoqbdropdown", {}, (err, res) => {
        if (res?.data?.status === 200) {
          setRQBVideoList(res?.data?.data);
          setRQBVideoLoader(false);
        } else {
          setRQBVideoList([]);
          setRQBVideoLoader(false);
        }
      });
  }

  const fetchVideoCatList = async () => {
    setVideoCatLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll("videos/categorylist", { ...videoCatTableFilter }, (err, res) => {
        if (res?.data?.status === 200) {
          setVideoCatList(res?.data?.data);
          setVideoCatLoader(false);
        } else {
          setVideoCatList([]);
          setVideoCatLoader(false);
        }
      });
  }
  const addInsSubmit = async (data = {}) => {
    setAddInsLoader(true);
    if (localStorage.getItem("rxdx_admin_login")) {
      // const form_data = new FormData();
      // Object.entries(data).forEach(([key, value]) => {
      //   if(value !== undefined && value !== null && value !== ""){
      //     form_data.append(key, value);
      //   }
      // })
      await api.create("instructor/createinstructor", data, (err, res) => {
        if (res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          setAddInsPopup(false);
          addInsForm.resetFields();
          setAddInsLoader(false);
          fetchInsTableList();
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
          setAddInsLoader(false);
        }
      });
    }

  }
  const fetchinsSubjectList = async () => {
    setInsSubjectLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll('instructor/inssubjectlist', {}, (err, res) => {
        if (res) {
          setInsSubjectList(res?.data?.data);
        } else {
          setInsSubjectList([]);
        }
        setInsSubjectLoader(false);
      })
  }
  const fetchInsTableList = async () => {
    setInsTableLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll('instructor/instructorlist', { ...insTableFilter }, (err, res) => {
        if (res) {
          setInsList(res?.data?.data);
        } else {
          setInsList([]);
        }
        setInsTableLoader(false);
      })
  }
  const fetchSingleIns = async (id) => {
    setEditInsPopup(!editInsPopup);
    if (!id) {
      return;
    }
    setSingleInsLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.getSingle("instructor/singleinstructor", id, (err, res) => {
        if (res) {
          setGetSingleIns(res?.data?.data);
          editInsForm.setFieldsValue(res?.data?.data);
        } else {
          setGetSingleIns({});
        }
        setSingleInsLoader(false);
      })
  }
  const updateInsSubmit = async (data = {}) => {
    setEditInsLoader(true);
    if (localStorage.getItem("rxdx_admin_login")) {
      // const form_data = new FormData();
      // Object.entries(data).forEach(([key, value]) => {
      //   if(value !== undefined && value !== null && value !== ""){
      //     form_data.append(key, value);
      //   }
      // })
      data.status = data.status ? 1 : 0
      await api.update("instructor/updateinstructor", getSingleIns?._id, data, (err, res) => {
        if (res?.data?.status === 200) {
          Widget.showMessage("success", res?.data?.message);
          setEditInsPopup(false);
          editInsForm.resetFields();
          setEditInsLoader(false);
          fetchInsTableList();
        } else {
          Widget.showMessage("error", err?.response?.data?.message);
          setEditInsLoader(false);
        }
      });
    }

  }
  const addVideoSubmit = async (data, cid,callback=null) => {
    setAddVideoLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.create('videos/createvideov2', { ...data, topic_id: cid }, (err, res) => {
        if (res?.data?.status === 200) {
          // fetchVideoListTable(cid);
          setAddVideoPopup(false);
          addVideoForm.resetFields();
          callback && callback(err, res);
          Widget.showMessage("success", res?.data?.message);
        } else {
          console.log("first")
          Widget.showMessage("error", err?.response?.data?.message);
        }
        setAddVideoLoader(false);
      })
  }
  const fetchVideoListTable = async (cid) => {
    setVideoListLoader(true);
    const filter = {
      ...videoListTable, subject_id: videoListTable?.subject_id?.filter((item) => item !== "subject").join("|"),
      topic_id: videoListTable?.topic_id?.filter((item) => item !== "topic").join("|"),
      subcategory_id: videoListTable?.subcategory_id?.filter((item) => item !== "subcategory").join("|")
    };
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll('videos/videotablelist', { ...filter, category_id: cid }, (err, res) => {
        if (res) {
          setVideoList(res?.data?.data);
        } else {
          setVideoList([]);
        }
        setVideoListLoader(false);
      })
  };
  const fetchVideoListTable1 = async (cid) => {
    const filter = {
      ...videoListTable, subject_id: videoListTable?.subject_id?.filter((item) => item !== "subject").join("|"),
      topic_id: videoListTable?.topic_id?.filter((item) => item !== "topic").join("|"),
      subcategory_id: videoListTable?.subcategory_id?.filter((item) => item !== "subcategory").join("|")
    };
    localStorage.getItem("rxdx_admin_login") &&
      await api.getAll('videos/videotablelist', { ...filter, category_id: cid }, (err, res) => {
        if (res) {
          setVideoList(res?.data?.data);
        } else {
          setVideoList([]);
        }
      })
  };
  const tpStreameGetVideoDetails = async (vid) => {
    setVerifyLoader(true);
    const res = await fetch(`https://app.tpstreams.com/api/v1/etu8th/assets/${vid}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Authorization": `token 5216b368374cdac74c76ce9ac310f61bbded49c9994552dc236df22eedc4b7ae`,
      },
    });
    const data = await res.json();
    if (!data?.id) {
      Widget.showMessage("error", "Video not found");
      setVerifyLoader(false);
      return
    }
    if (data?.id) {
      setAddVideoFormData((prev) => {
        return { ...prev, video_id: data?.id, video_details: data }
      })
      const vid1 = formatDuration(data?.video?.duration)
      setMaxDuration(vid1);
      const res = await fetch(`https://app.tpstreams.com/api/v1/etu8th/assets/${vid}/access_tokens/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `token 5216b368374cdac74c76ce9ac310f61bbded49c9994552dc236df22eedc4b7ae`,
        },
      });
      const data1 = await res.json();
      if (!data1?.code) {
        Widget.showMessage("error", "Video access token creation failed");
        setVerifyLoader(false);
        return
      }
      if (data1?.code) {
        setAddVideoFormData((prev) => {
          return { ...prev, video_details: { ...prev?.video_details, access_token: data1 } }
        })
        Widget.showMessage("success", "Video verified successfully");
        setVerifyLoader(false);
      }
    }

  }

  function formatDuration(seconds) {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    const formattedHours = String(hours).padStart(2, '0');
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(secs).padStart(2, '0');
    // return {
    //   formattedHours:parseInt(formattedHours),
    //   formattedMinutes:parseInt(formattedMinutes),
    //   formattedSeconds:parseInt(formattedSeconds)
    // }
    // setMaxDuration({
    //   formattedHours,
    //   formattedMinutes,
    //   formattedSeconds
    // })
    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
  }


  const updateVideos = async (id) => {
    if (!localStorage.getItem("rxdx_admin_login")) {
      return;
    }
    if (!id) {
      return;
    }
    setUpdateVideoLoader(true);
    const formData = new FormData();
    formData.append("name", addVideoFormData?.name);
    formData.append("description", addVideoFormData?.description);
    formData.append("time_stamp_status", Number(addVideoFormData?.time_stamp_status == true ? 1 : 0));
    addVideoFormData?.time_stamp_details?.forEach((detail, index) => {
      formData.append(`time_stamp_details[${index}][time]`, detail?.time);
      formData.append(`time_stamp_details[${index}][description]`, detail?.description);
      if (detail?._id) {
        formData.append(`time_stamp_details[${index}][_id]`, detail?._id);
      }

    });
    formData.append("notes_type", addVideoFormData?.notes_type);
    formData.append("notes_image", addVideoFormData?.notes_image);
    formData.append("notes_pdf", addVideoFormData?.notes_pdf);
    formData.append("notes_text", addVideoFormData?.notes_text);
    formData.append("download_option", addVideoFormData?.download_option);
    formData.append("free_playback_from", addVideoFormData?.free_playback_from);
    formData.append("free_playback_to", addVideoFormData?.free_playback_to);
    formData.append("video_id", addVideoFormData?.video_id);
    formData.append("video_details", JSON.stringify(addVideoFormData?.video_details));
    formData.append("status", addVideoFormData?.status == true ? 1 : 0);
    formData.append("notes_status", addVideoFormData.notes_status == true ? 1 : 0);
    if (addVideoFormData?.related_qbanks) {

      addVideoFormData?.related_qbanks?.forEach((tag) => {
        formData.append("related_qbanks[]", tag);
      });
    }
    await api.update("videos/updatevideo", id, formData, (err, res) => {
      if (res?.data?.status === 200) {
        Widget.showMessage("success", res?.data?.message);
        setUpdateVideoLoader(false);
        fetchSingleVideo(id);
      } else {
        Widget.showMessage("error", err?.response?.data?.message);
        setUpdateVideoLoader(false);
      }
    })

  }

  const fetchSingleVideo = async (id) => {
    if (!localStorage.getItem("rxdx_admin_login")) {
      return;
    }
    if (!id) {
      return;
    }
    setSingleVideoLoader(true);
    await api.getSingle(`videos/singlevideo`, id, (err, res) => {
      if (res?.data?.status === 200) {
        setSingleVideo(res?.data?.data);
        setAddVideoFormData(res?.data?.data);
        const vid1 = formatDuration(res?.data?.data?.video_details?.video?.duration)
        setMaxDuration(vid1);
        if (res?.data?.data?.time_stamp_details.length === 0) {
          setAddVideoFormData((prev) => {
            return { ...prev, time_stamp_details: [{ time: "", description: "" }] }
          })
        }
        setSingleVideoLoader(false);
      } else {
        // Widget.showMessage("error", err?.response?.data?.message);
        setSingleVideoLoader(false);
      }
    })
  }

  const statusUpdate = async (status = null, id = null, cid = null) => {
    if (!id && !cid && !localStorage.getItem("rxdx_admin_login")) {
      Widget.showMessage("error", "ID is required");
      return;
    }
    const formData = new FormData();
    formData.append("status", status);
    await api.update("videos/updatevideo", id, formData, (err, res) => {
      if (res?.data?.status === 200) {
        Widget.showMessage("success", res?.data?.message);
        setUpdateVideoLoader(false);
        fetchVideoListTable(cid);
      } else {
        Widget.showMessage("error", err?.response?.data?.message);
        setUpdateVideoLoader(false);
      }
    })
  }

  const bulkActionVideo = async (ids = [], action = null, cid = null,callback=null) => {
    if (ids.length === 0) return;
    if (!action) return;
    setBulkActionVideoExamLoader(true);
    localStorage.getItem("rxdx_admin_login") &&
      await api.create("examsnew/bulk_action_video", {
        ids: ids,
        action: action
      }, (err, res) => {
        if (res?.data?.status === 200) {
          cid && fetchVideoListTable(cid);
          setBulkActionVideoExam([]);
          callback && callback();
          setBulkActionVideoExamLoader(false);
        } else {
          setBulkActionVideoExamLoader(false);
        }
      });
  }
  return (
    <Context.Provider
      value={{
        ...props,
        videoCatLoader, setVideoCatLoader,
        videoCatList, setVideoCatList,
        videoCatTableFilter, setVideoCatTableFilter,
        fetchVideoCatList,
        addInsPopup, setAddInsPopup,
        addInsLoader, setAddInsLoader,
        addInsFormData, setAddInsFormData,
        addInsSubmit,
        insSubjectList, setInsSubjectList,
        insSubjectLoader, setInsSubjectLoader,
        fetchinsSubjectList,
        addInsForm,
        fetchInsTableList,
        insTableFilter, setInsTableFilter,
        insList, setInsList,
        insTableLoader, setInsTableLoader,
        editInsForm,
        editInsPopup, setEditInsPopup,
        editInsLoader, setEditInsLoader,
        getSingleIns, setGetSingleIns,
        singleInsLoader, setSingleInsLoader,
        fetchSingleIns,
        updateInsSubmit,
        addVideoSubmit,
        addVideoLoader, setAddVideoLoader,
        addVideoPopup, setAddVideoPopup,
        addVideoForm,
        fetchVideoListTable,
        videoList, setVideoList,
        videoListLoader, setVideoListLoader,
        videoListTable, setVideoListTable,
        addVideoFormData, setAddVideoFormData,
        tpStreameGetVideoDetails,
        verifyLoader, setVerifyLoader,
        formatDuration,
        maxDuration, setMaxDuration,
        updateVideos,
        updateVideoLoader, setUpdateVideoLoader,
        singleVideoLoader, setSingleVideoLoader,
        singleVideo, setSingleVideo,
        fetchSingleVideo,
        statusUpdate,
        rQBLoader, setRQBVideoLoader,
        rQBList, setRQBVideoList,
        fetchRelatedQB,
        fetchVideoTList,
        videoTList, setVideoTList,
        videoTLoader, setVideoTLoader,
        videoRowUpdate,
        deleteVideo,
        deleteVideoLoader,
        gumletVideoStatusLoader, setGumletVideoStatusLoader,
        updateGumletVideoStatus,
        gumletAssetId, setGumletAssetId,
        bulkActionVideo,
        bulkActionVideoExam, setBulkActionVideoExam,
        bulkActionVideoExamLoader, setBulkActionVideoExamLoader,
        bulkActionVideoType, setBulkActionVideoType,
        //video

        fetRatingData, setFetRatingData,
        fetRatingDataLoader, setFetRatingDataLoader,
        updateRatingData, setUpdateRatingData,
        updateRatingDataLoader, setUpdateRatingDataLoader,
        getRatingData,
        updateRatingPopup, setUpdateRatingPopup,
        getRatingDataUpdate
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

export default TopicMasterProvider;
